import type { KnowledgeItem } from '../types';

export interface WordPhrase {
  en: string;
  zh: string;
}

const exactPhrases: Record<string, WordPhrase> = {
  hello: { en: 'Hello!', zh: '你好！' },
  goodbye: { en: 'Goodbye!', zh: '再见！' },
  please: { en: 'Please help me.', zh: '请帮帮我。' },
  sorry: { en: 'I am sorry.', zh: '对不起。' },
  thank: { en: 'Thank you.', zh: '谢谢你。' },
  thanks: { en: 'Thanks!', zh: '谢谢！' },
  yes: { en: 'Yes, I can.', zh: '是的，我可以。' },
  no: { en: 'No, thank you.', zh: '不用了，谢谢。' },
  okay: { en: 'Okay, let us go.', zh: '好的，我们走吧。' },
  up: { en: 'Look up.', zh: '向上看。' },
  down: { en: 'Sit down.', zh: '坐下来。' },
  left: { en: 'Turn left.', zh: '向左转。' },
  right: { en: 'Turn right.', zh: '向右转。' },
  in: { en: 'The ball is in the box.', zh: '球在盒子里面。' },
  out: { en: 'The ball is out.', zh: '球出来了。' },
  on: { en: 'The book is on the desk.', zh: '书在桌子上。' },
  under: { en: 'The cat is under the chair.', zh: '猫在椅子下面。' },
  over: { en: 'The bird flies over the tree.', zh: '小鸟飞过树。' },
  near: { en: 'The cat is near me.', zh: '猫在我旁边。' },
  far: { en: 'The star is far away.', zh: '星星在很远的地方。' },
  here: { en: 'Come here.', zh: '过来。' },
  there: { en: 'Look over there.', zh: '看那边。' },
  us: { en: 'Play with us.', zh: '和我们一起玩。' },
  rain: { en: 'It is raining.', zh: '下雨了。' },
  snow: { en: 'It is snowing.', zh: '下雪了。' },
  wind: { en: 'The wind is blowing.', zh: '风在吹。' },
  storm: { en: 'A storm is coming.', zh: '暴风雨要来了。' },
  rainbow: { en: 'I see a rainbow.', zh: '我看见彩虹了。' },
  star: { en: 'I see a star.', zh: '我看见一颗星星。' },
  sky: { en: 'I can see the sky.', zh: '我能看见天空。' },
  cloud: { en: 'I see a cloud.', zh: '我看见一朵云。' },
  flower: { en: 'This is a flower.', zh: '这是一朵花。' },
  grass: { en: 'The grass is green.', zh: '草是绿色的。' },
  leaf: { en: 'This is a leaf.', zh: '这是一片叶子。' },
  river: { en: 'I can see a river.', zh: '我能看见一条河。' },
  lake: { en: 'I can see a lake.', zh: '我能看见一个湖。' },
  mountain: { en: 'This is a mountain.', zh: '这是一座山。' },
  hill: { en: 'This is a hill.', zh: '这是一座小山。' },
  sea: { en: 'I like the sea.', zh: '我喜欢大海。' },
  ocean: { en: 'The ocean is blue.', zh: '海洋是蓝色的。' },
  beach: { en: 'Let us go to the beach.', zh: '我们去海滩吧。' },
  spring: { en: 'It is spring.', zh: '春天来了。' },
  summer: { en: 'It is summer.', zh: '夏天来了。' },
  autumn: { en: 'It is autumn.', zh: '秋天来了。' },
  winter: { en: 'It is winter.', zh: '冬天来了。' },
  morning: { en: 'Good morning!', zh: '早上好！' },
  afternoon: { en: 'Good afternoon!', zh: '下午好！' },
  evening: { en: 'Good evening!', zh: '晚上好！' },
  night: { en: 'Good night!', zh: '晚安！' },
  today: { en: 'Today is a happy day.', zh: '今天是快乐的一天。' },
  tomorrow: { en: 'See you tomorrow.', zh: '明天见。' },
  yesterday: { en: 'Yesterday was fun.', zh: '昨天很开心。' },
  week: { en: 'One week.', zh: '一周。' },
  month: { en: 'One month.', zh: '一个月。' },
  year: { en: 'One year.', zh: '一年。' },
  birthday: { en: 'It is my birthday.', zh: '今天是我的生日。' },
  holiday: { en: 'It is a happy holiday.', zh: '这是一个快乐的假日。' },
  happy: { en: 'I am happy.', zh: '我很开心。' },
  sad: { en: 'I am sad.', zh: '我有点难过。' },
  angry: { en: 'I am angry.', zh: '我生气了。' },
  scared: { en: 'I am scared.', zh: '我有点害怕。' },
  tired: { en: 'I am tired.', zh: '我累了。' },
  excited: { en: 'I am excited.', zh: '我很兴奋。' },
  surprised: { en: 'I am surprised.', zh: '我很惊讶。' },
  bored: { en: 'I am bored.', zh: '我觉得有点无聊。' },
  calm: { en: 'I am calm.', zh: '我很平静。' },
  sleepy: { en: 'I am sleepy.', zh: '我困了。' },
  hungry: { en: 'I am hungry.', zh: '我饿了。' },
  thirsty: { en: 'I am thirsty.', zh: '我渴了。' },
  big: { en: 'The elephant is big.', zh: '大象很大。' },
  small: { en: 'The mouse is small.', zh: '小老鼠很小。' },
  tall: { en: 'The tree is tall.', zh: '这棵树很高。' },
  short: { en: 'The pencil is short.', zh: '这支铅笔很短。' },
  long: { en: 'The snake is long.', zh: '这条蛇很长。' },
  fast: { en: 'The car is fast.', zh: '这辆车很快。' },
  slow: { en: 'The turtle is slow.', zh: '乌龟很慢。' },
  hot: { en: 'It is hot.', zh: '天气很热。' },
  cold: { en: 'It is cold.', zh: '天气很冷。' },
  warm: { en: 'It is warm.', zh: '天气很暖和。' },
  cool: { en: 'It is cool.', zh: '天气很凉爽。' },
  clean: { en: 'It is clean.', zh: '它是干净的。' },
  dirty: { en: 'It is dirty.', zh: '它是脏的。' },
  new: { en: 'It is new.', zh: '它是新的。' },
  old: { en: 'The tree is old.', zh: '这棵树很老。' },
  young: { en: 'I am young.', zh: '我还小。' },
  beautiful: { en: 'It is beautiful.', zh: '它很美。' },
  cute: { en: 'It is cute.', zh: '它很可爱。' },
  funny: { en: 'It is funny.', zh: '它很有趣。' },
  kind: { en: 'Be kind.', zh: '要友善。' },
  brave: { en: 'I am brave.', zh: '我很勇敢。' },
  school: { en: 'I go to school.', zh: '我去学校。' },
  classroom: { en: 'This is my classroom.', zh: '这是我的教室。' },
  house: { en: 'This is my house.', zh: '这是我的房子。' },
  home: { en: 'I am at home.', zh: '我在家。' },
  room: { en: 'This is my room.', zh: '这是我的房间。' },
  kitchen: { en: 'This is the kitchen.', zh: '这是厨房。' },
  bedroom: { en: 'This is my bedroom.', zh: '这是我的卧室。' },
  bathroom: { en: 'This is the bathroom.', zh: '这是浴室。' },
  city: { en: 'I live in a city.', zh: '我住在城市里。' },
  village: { en: 'I live in a village.', zh: '我住在村庄里。' },
  store: { en: 'I go to the store.', zh: '我去商店。' },
  hotel: { en: 'This is a hotel.', zh: '这是一家旅馆。' },
  office: { en: 'This is an office.', zh: '这是一间办公室。' },
  university: { en: 'This is a university.', zh: '这是一所大学。' },
  community: { en: 'This is my community.', zh: '这是我的社区。' },
  circle: { en: 'It is a circle.', zh: '它是一个圆形。' },
  square: { en: 'It is a square.', zh: '它是一个正方形。' },
  triangle: { en: 'It is a triangle.', zh: '它是一个三角形。' },
  rectangle: { en: 'It is a rectangle.', zh: '它是一个长方形。' },
  time: { en: 'It is time to play.', zh: '该玩了。' },
  day: { en: 'A happy day.', zh: '快乐的一天。' },
  music: { en: 'I like music.', zh: '我喜欢音乐。' },
  video: { en: 'Let us watch a video.', zh: '我们看视频吧。' },
  map: { en: 'Look at the map.', zh: '看看地图。' },
  game: { en: 'Let us play a game.', zh: '我们玩游戏吧。' },
  games: { en: 'Let us play games.', zh: '我们玩游戏吧。' },
  photo: { en: 'This is a photo.', zh: '这是一张照片。' },
  cat: { en: 'The cat is cute.', zh: '这只猫很可爱。' },
  dog: { en: 'The dog can run.', zh: '小狗会跑。' },
  apple: { en: 'I like apples.', zh: '我喜欢苹果。' },
  banana: { en: 'I like bananas.', zh: '我喜欢香蕉。' },
  book: { en: 'This is my book.', zh: '这是我的书。' },
  moon: { en: 'I see the moon.', zh: '我看见月亮了。' },
  sun: { en: 'The sun is bright.', zh: '太阳很明亮。' },
  tree: { en: 'This is a tree.', zh: '这是一棵树。' }
};

const colorPhrases: Record<string, WordPhrase> = {
  red: { en: 'It is red.', zh: '它是红色的。' },
  yellow: { en: 'It is yellow.', zh: '它是黄色的。' },
  green: { en: 'It is green.', zh: '它是绿色的。' },
  blue: { en: 'It is blue.', zh: '它是蓝色的。' },
  purple: { en: 'It is purple.', zh: '它是紫色的。' },
  pink: { en: 'It is pink.', zh: '它是粉色的。' },
  black: { en: 'It is black.', zh: '它是黑色的。' },
  white: { en: 'It is white.', zh: '它是白色的。' },
  brown: { en: 'It is brown.', zh: '它是棕色的。' },
  gray: { en: 'It is gray.', zh: '它是灰色的。' },
  grey: { en: 'It is grey.', zh: '它是灰色的。' },
  gold: { en: 'It is gold.', zh: '它是金色的。' },
  silver: { en: 'It is silver.', zh: '它是银色的。' }
};

const numberWords = new Set([
  'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
  'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen',
  'eighteen', 'nineteen', 'twenty'
]);

const familyWords = new Set(['mother', 'father', 'sister', 'brother', 'baby', 'family', 'friend']);

const peopleWords = new Set([
  'teacher', 'student', 'doctor', 'nurse', 'police', 'officer', 'farmer', 'driver',
  'singer', 'painter', 'pilot', 'cook'
]);

const animalWords = new Set([
  'bird', 'fish', 'tiger', 'lion', 'elephant', 'monkey', 'panda', 'rabbit', 'bear',
  'horse', 'cow', 'sheep', 'pig', 'duck', 'chicken', 'mouse', 'frog', 'turtle',
  'dolphin', 'whale', 'butterfly', 'bee', 'ant', 'spider'
]);

const foodWords = new Set([
  'orange', 'grape', 'strawberry', 'pear', 'peach', 'watermelon', 'lemon', 'mango',
  'cherry', 'carrot', 'tomato', 'potato', 'onion', 'pumpkin', 'corn', 'bread',
  'milk', 'water', 'juice', 'rice', 'noodle', 'egg', 'cake', 'candy', 'cookie',
  'chocolate', 'cheese', 'soup', 'meat', 'beef', 'pork', 'salad', 'sandwich', 'pizza'
]);

const foodPlural: Record<string, string> = {
  orange: 'oranges',
  grape: 'grapes',
  strawberry: 'strawberries',
  pear: 'pears',
  peach: 'peaches',
  lemon: 'lemons',
  mango: 'mangoes',
  cherry: 'cherries',
  carrot: 'carrots',
  tomato: 'tomatoes',
  potato: 'potatoes',
  onion: 'onions',
  egg: 'eggs',
  noodle: 'noodles',
  cookie: 'cookies',
  sandwich: 'sandwiches'
};

const bodyWords = new Set([
  'head', 'eye', 'ear', 'nose', 'mouth', 'hand', 'foot', 'arm', 'leg', 'face',
  'hair', 'tooth', 'tongue', 'finger', 'knee', 'shoulder', 'back', 'heart'
]);

const vehicleWords = new Set([
  'car', 'bus', 'train', 'bike', 'bicycle', 'plane', 'boat', 'ship', 'taxi', 'truck'
]);

const verbPhrases: Record<string, WordPhrase> = {
  eat: { en: 'I can eat.', zh: '我会自己吃饭。' },
  drink: { en: 'I can drink.', zh: '我会喝水。' },
  run: { en: 'I can run.', zh: '我会跑。' },
  walk: { en: 'I can walk.', zh: '我会走。' },
  jump: { en: 'I can jump.', zh: '我会跳。' },
  swim: { en: 'I can swim.', zh: '我会游泳。' },
  sing: { en: 'I can sing.', zh: '我会唱歌。' },
  dance: { en: 'I can dance.', zh: '我会跳舞。' },
  read: { en: 'I can read.', zh: '我会读书。' },
  write: { en: 'I can write.', zh: '我会写字。' },
  draw: { en: 'I can draw.', zh: '我会画画。' },
  paint: { en: 'I can paint.', zh: '我会画画。' },
  play: { en: 'I can play.', zh: '我会玩。' },
  sleep: { en: 'I can sleep.', zh: '我会自己睡觉。' },
  wake: { en: 'I can wake up.', zh: '我会醒来。' },
  sit: { en: 'I can sit.', zh: '我会坐。' },
  stand: { en: 'I can stand.', zh: '我会站。' },
  open: { en: 'I can open it.', zh: '我会打开它。' },
  close: { en: 'I can close it.', zh: '我会关上它。' },
  look: { en: 'I can look.', zh: '我会看一看。' },
  listen: { en: 'I can listen.', zh: '我会听。' },
  speak: { en: 'I can speak.', zh: '我会说。' },
  love: { en: 'I love you.', zh: '我爱你。' },
  like: { en: 'I like it.', zh: '我喜欢它。' },
  want: { en: 'I want it.', zh: '我想要它。' },
  need: { en: 'I need help.', zh: '我需要帮助。' },
  help: { en: 'I can help.', zh: '我会帮忙。' },
  give: { en: 'I can give.', zh: '我会给。' },
  take: { en: 'I can take it.', zh: '我会拿。' },
  make: { en: 'I can make it.', zh: '我会做。' },
  build: { en: 'I can build it.', zh: '我会搭建。' },
  find: { en: 'I can find it.', zh: '我能找到它。' },
  start: { en: 'Let us start.', zh: '我们开始吧。' },
  stop: { en: 'Please stop.', zh: '请停下来。' },
  turn: { en: 'I can turn.', zh: '我会转弯。' },
  push: { en: 'I can push.', zh: '我会推。' },
  pull: { en: 'I can pull.', zh: '我会拉。' },
  carry: { en: 'I can carry it.', zh: '我会拿。' },
  climb: { en: 'I can climb.', zh: '我会爬。' },
  ride: { en: 'I can ride.', zh: '我会骑。' },
  fly: { en: 'I can fly.', zh: '我会飞。' },
  use: { en: 'I can use it.', zh: '我会用它。' },
  see: { en: 'I can see.', zh: '我能看见。' },
  go: { en: 'Let us go.', zh: '我们走吧。' },
  work: { en: 'I can work.', zh: '我会工作。' },
  buy: { en: 'I can buy it.', zh: '我可以买它。' },
  add: { en: 'I can add.', zh: '我会加上。' },
  send: { en: 'I can send it.', zh: '我可以发送。' },
  show: { en: 'Let me show you.', zh: '我做给你看。' },
  check: { en: 'I can check.', zh: '我会检查。' },
  download: { en: 'I can download.', zh: '我会下载。' },
  travel: { en: 'Let us travel.', zh: '我们去旅行吧。' },
  think: { en: 'I can think.', zh: '我会思考。' },
  know: { en: 'I know.', zh: '我知道。' }
};

const pluralWords = new Set([
  'books', 'years', 'items', 'comments', 'details', 'terms', 'hotels', 'results',
  'states', 'prices', 'pages', 'members', 'systems', 'resources'
]);

const uncountableWords = new Set([
  'information', 'time', 'music', 'work', 'software', 'data', 'health', 'education',
  'security', 'power', 'research', 'technology', 'mail', 'world', 'life', 'management',
  'support', 'policy', 'copyright', 'design', 'internet', 'shipping', 'access'
]);

const sentenceFunctionWords = new Set([
  'a', 'an', 'and', 'are', 'can', 'come', 'do', 'for', 'good', 'here', 'i', 'in', 'is',
  'it', 'its', 'like', 'look', 'me', 'my', 'no', 'not', 'on', 'one', 'our', 'play',
  'please', 'see', 'sit', 'thank', 'that', 'the', 'these', 'they', 'this', 'to', 'today',
  'turn', 'two', 'under', 'up', 'us', 'very', 'we', 'with', 'yes', 'you', 'your'
]);

const childFriendlySentenceWords = new Set(sentenceFunctionWords);
for (const phrase of [...Object.values(exactPhrases), ...Object.values(colorPhrases), ...Object.values(verbPhrases)]) {
  for (const token of phrase.en.toLowerCase().match(/[a-z]+/g) ?? []) {
    childFriendlySentenceWords.add(token);
  }
}

function isChildFriendlySentence(sentence: string, targetWord: string) {
  const tokens = sentence.toLowerCase().replace(/['’]/g, '').match(/[a-z]+/g) ?? [];
  return tokens.length > 0
    && tokens.length <= 7
    && tokens.every((token) => token === targetWord || childFriendlySentenceWords.has(token));
}

function cleanMeaning(item: KnowledgeItem) {
  return (item.meaning || item.title)
    .replace(/\([^)]*\)/g, '')
    .replace(/[（(].*?[）)]/g, '')
    .split(/[，,、/]/)[0]
    .trim();
}

function articleFor(word: string) {
  return /^[aeiou]/i.test(word) ? 'an' : 'a';
}

export function getWordPhrase(item: KnowledgeItem): WordPhrase {
  const word = item.title.trim().toLowerCase();
  const meaning = cleanMeaning(item);

  if (item.exampleSentence && isChildFriendlySentence(item.exampleSentence, word)) {
    return {
      en: item.exampleSentence,
      zh: item.exampleTranslation || meaning
    };
  }
  if (exactPhrases[word]) return exactPhrases[word];
  if (colorPhrases[word]) return colorPhrases[word];

  if (numberWords.has(word)) {
    return {
      en: word === 'one' ? 'I see one star.' : `I see ${word} stars.`,
      zh: `我看见${numberLabels[word] || meaning}颗星星。`
    };
  }
  if (familyWords.has(word)) {
    return { en: `This is my ${word}.`, zh: `这是我的${meaning}。` };
  }
  if (peopleWords.has(word)) {
    return { en: `This is ${articleFor(word)} ${word}.`, zh: `这是一位${meaning}。` };
  }
  if (animalWords.has(word)) {
    return { en: `I see ${articleFor(word)} ${word}.`, zh: `我看见一只${meaning}。` };
  }
  if (foodWords.has(word)) {
    const plural = foodPlural[word] || word;
    return { en: `I like ${plural}.`, zh: `我喜欢${meaning}。` };
  }
  if (bodyWords.has(word)) {
    return { en: `This is my ${word}.`, zh: `这是我的${meaning}。` };
  }
  if (vehicleWords.has(word)) {
    return { en: `I see ${articleFor(word)} ${word}.`, zh: `我看见一辆${meaning}。` };
  }
  if (verbPhrases[word]) return verbPhrases[word];

  if (uncountableWords.has(word)) {
    return { en: `We learn ${word}.`, zh: `我们学习${meaning}。` };
  }
  if (pluralWords.has(word)) {
    return { en: `These are ${word}.`, zh: `这些是${meaning}。` };
  }
  return {
    en: `This is ${articleFor(word)} ${word}.`,
    zh: `这是${meaning}。`
  };
}
const numberLabels: Record<string, string> = {
  one: '一',
  two: '两',
  three: '三',
  four: '四',
  five: '五',
  six: '六',
  seven: '七',
  eight: '八',
  nine: '九',
  ten: '十',
  eleven: '十一',
  twelve: '十二',
  thirteen: '十三',
  fourteen: '十四',
  fifteen: '十五',
  sixteen: '十六',
  seventeen: '十七',
  eighteen: '十八',
  nineteen: '十九',
  twenty: '二十'
};
